module.exports = __webpack_public_path__ + "static/icon-7f5ab49f65a8ae235e3e6de27182469e.png";